"use strict";

exports.__esModule = true;
exports.EnvController = void 0;
var _react = require("react");
var _determineLocale = require("../Locale/determineLocale");
var _constants = require("../Locale/constants");
var _constants2 = require("../../Auth/constants");
var _timeDefinitions = require("../../timeDefinitions");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function makeState(props) {
  return {
    licence: props.licence || _constants2.DEFAULT_LICENCES.demoLicence,
    apiURL: props.apiURL,
    websocketURL: props.websocketURL,
    featureFlags: props.featureFlags || [],
    locale: (0, _determineLocale.determineLocale)(),
    googleMapAPIKey: props.googleMapAPIKey || "",
    clientId: props.clientId || "",
    clientSecret: props.clientSecret || "",
    plant: props.plant || "",
    defaultDocumentationUrl: props.defaultDocumentationUrl || "",
    defaultCustomerSupportUrl: props.defaultCustomerSupportUrl || "",
    deviceConnectionTimeout: props.deviceConnectionTimeout || 40000,
    deviceLagThreshold: props.deviceLagThreshold || 60000,
    warningClassificationTime: (0, _timeDefinitions.getHoursMillis)(props.warningClassificationTime) || _timeDefinitions.DAY_IN_MILLIS,
    imageInputMaxSizeInKB: props.imageInputMaxSizeInKB || 10000,
    administrativePlantName: props.administrativePlantName || "systeminsights",
    notificationsInterval: props.notificationsInterval || 60000,
    triggerSubscriptionInterval: props.triggerSubscriptionInterval || 60000,
    changeLocale: function changeLocale(localeID) {
      if (localeID !== this.locale.locale && _constants.SUPPORTED_LOCALES[localeID]) {
        localStorage.setItem(_constants.STORAGE_LOCALE_KEY, localeID);
        this.locale = _constants.SUPPORTED_LOCALES[localeID];
        window.location.reload();
      }
    }
  };
}

/**
 * Controller for locale
 * @component
 */
// eslint-disable-next-line react/no-multi-comp
var EnvController = exports.EnvController = /*#__PURE__*/function (_Component) {
  function EnvController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(EnvController, _Component);
  var _proto = EnvController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return EnvController;
}(_react.Component);
EnvController.defaultProps = {};
EnvController.displayName = "EnvController";